import {Container, SmallView, Text1, Title1, View} from "../../../../styles/business-components";
import * as S from './styles'

import Image from '../../../../assets/images/business/b_m_cnt4_img1.png'

export const Content4 = () => {
    return (
        <Container>
            <View>
                <S.Content>
                    <div>
                        <Title1>Звоните на стационарные телефоны в любую точку мира</Title1>
                        <Text1>Пользуйтесь IP-телефонией от TeleGuard в разных странах и сетях с отличным качеством звука. </Text1>
                        <Text1>Лучшее соотношение цены и качества.</Text1>
                    </div>
                    <div>
                        <S.Image src={Image}/>
                    </div>
                </S.Content>
            </View>
            <SmallView>
                <Title1>Звоните на стационарные телефоны в любую точку мира</Title1>
                <S.SmallContent>
                    <div>
                        <Text1>Пользуйтесь IP-телефонией от TeleGuard в разных странах и сетях с отличным качеством звука. </Text1>
                        <Text1>Лучшее соотношение цены и качества.</Text1>
                    </div>
                    <div>
                        <S.Image src={Image}/>
                    </div>
                </S.SmallContent>
            </SmallView>
        </Container>
    )
}